/**
 * Steps Animation Module
 * Anime les étapes de la section explanation au scroll avec GSAP
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class StepsAnimation {
  constructor() {
    this.steps = document.querySelectorAll('.step-item');
    
    if (this.steps.length > 0) {
      this.init();
    }
  }

  init() {
    this.steps.forEach((step, index) => {
      const number = step.querySelector('.step-item__number');
      const title = step.querySelector('.step-item__title');
      const text = step.querySelector('.step-item__text');
      const line = step;

      // Timeline pour chaque étape
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: step,
          start: 'top 80%',
          toggleActions: 'play none none none',
        }
      });

      // Animation du numéro avec effet pop et rotation
      tl.to(number, {
        opacity: 1,
        scale: 1,
        rotation: 0,
        duration: 0.5,
        ease: 'back.out(1.7)',
      });

      // Animation du titre depuis la gauche
      tl.to(title, {
        opacity: 1,
        x: 0,
        duration: 0.5,
        ease: 'power2.out',
      }, '-=0.3');

      // Animation du texte depuis le bas
      tl.to(text, {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: 'power2.out',
      }, '-=0.3');

      // Animation de la ligne pointillée (sauf pour la dernière étape)
      // On utilise une classe CSS pour l'animer
      if (index < this.steps.length - 1) {
        tl.call(() => {
          step.classList.add('line-animated');
        }, null, '-=0.2');
      }
    });
  }
}
